import React from 'react';
import { SendProtocolModal, Card, ExamTable } from 'components';
import { NeedingAttentionMappedExamStatuses } from '../../helpers/enums';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { IExam, ISignCurrentSovietProtocols } from '../../api/ApiClient';
import { getExamTimesLeftSubStatus } from '_helpers';
import { useLocalErrorHandler } from 'hooks';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import query from '../../helpers/const/query';

const SovietProtocolsContainer = ({
    apiError,
    loading,
    setErrorHandler,
    profile,
    sendCodeProcessing,
    smsCodeStatus,
    sendCodeForSignCurrentSovietProtocols,
    signCurrentSovietProtocols,
    fetchExamsForSigningSovietProtocols,
    examsForSigningSovietProtocolsList,
    onPush,
}: Props) => {
    useLocalErrorHandler(setErrorHandler);

    if (!profile || !profile.sovietMember) return null;

    const HEADER = [
        'Дата и время',
        'Квалификация',
        'Тип экзамена',
        'Требуется',
    ];

    React.useEffect(() => {
        fetchExamsForSigningSovietProtocols();
    }, []);

    const handleChooseExam = (id?: string) => {
        if (!id) return;
        onPush(`/exam/${id}?from=${query.FROM.SOVIET_PROTOCOLS}`);
    };

    const onSubmitCurrentSovietProtocols = async (data: ISignCurrentSovietProtocols) => {
        const res = await signCurrentSovietProtocols(data);

        if (res) {
            await fetchExamsForSigningSovietProtocols();
        }

        return res;
    };

    const getExamData = (exam: IExam) => {
        const status = NeedingAttentionMappedExamStatuses[exam.status];
        const subStatus = getExamTimesLeftSubStatus(exam);

        return {
            ...exam,
            status: { ...status, subStatus },
            name: exam.qualificationTitle,
            examType: exam.type,
        };
    };

    const renderHeaderChild = () => React.useMemo(() => (examsForSigningSovietProtocolsList && examsForSigningSovietProtocolsList.length
        ? (
            <SendProtocolModal
              buttonText="Подписать все открытые протоколы"
              modalTitle="Электронное подписание протоколов"
              modalBodyText="Для завершения подписания протоколов в электронной форме, введите код из СМС-сообщения, которое было отправлено на номер"
              sendCodeProcessing={sendCodeProcessing}
              smsCodeStatus={smsCodeStatus}
              authorizedExpert={profile}
              apiError={apiError}
              onSendCodeForSignCurrentSovietProtocols={sendCodeForSignCurrentSovietProtocols}
              onSubmitCurrentSovietProtocols={onSubmitCurrentSovietProtocols}
            />
        )
        : null), [examsForSigningSovietProtocolsList]);

    return (
        <Card
          withoutPadding
          title="Подписание протоколов совета"
          category="Список экзаменов нуждающихся в подписании протоколов совета"
          apiError={apiError}
          showLoader={loading}
          headerChild={renderHeaderChild()}
        >
            <ExamTable
              header={HEADER}
              tableRows={(examsForSigningSovietProtocolsList || []).map(getExamData)}
              onChooseExam={handleChooseExam}
              placeholderTitle="Нет экзаменов в списке"
              placeholderText="Здесь будут отображаться все экзамены, нуждающиеся в подписании протоколов совета"
            />
        </Card>
    );
};

const mapState = (state: IRootState) => ({
    examsForSigningSovietProtocolsList: state.exams.examsForSigningSovietProtocolsList,
    apiError: state.errors.error,
    profile: state.auth.auth ? state.auth.auth.profile : null,
    smsCodeStatus: state.exams.smsCodeStatus,
    loading: Boolean(state.loading.effects.exams.fetchExamsForSigningSovietProtocols),
    sendCodeProcessing: Boolean(state.loading.effects.exams.sendCodeForSignCurrentSovietProtocolsAsync),
});

const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
    setErrorHandler: dispatch.errors.setErrorHandler,
    fetchExamsForSigningSovietProtocols: dispatch.exams.fetchExamsForSigningSovietProtocols,
    signCurrentSovietProtocols: dispatch.exams.signCurrentSovietProtocolsAsync,
    sendCodeForSignCurrentSovietProtocols: dispatch.exams.sendCodeForSignCurrentSovietProtocolsAsync,
});

export default connect(mapState, mapDispatch)(SovietProtocolsContainer);

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>
type Props = connectedProps;
